const serverUrl = 'https://www.adamsuperfoods.com'

export default serverUrl